import { useEffect, useRef } from "react";

/**
 * Run `fn` when the component really unmounts. StrictMode's dev-only
 * mount → unmount → mount is ignored (the call is deferred a tick and
 * cancelled by the remount), so e.g. a handed-off Firebase identity isn't
 * signed out on a simulated unmount.
 */
export function useOnLeave(fn: () => void): void {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      setTimeout(() => {
        if (!mounted.current) fnRef.current();
      }, 0);
    };
  }, []);
}
